/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ArticlePastSearchContractResponse,
    ArticlePastSearchContractResponseFromJSON,
    ArticlePastSearchContractResponseToJSON,
    ArticlePastSearchCsv,
    ArticlePastSearchCsvFromJSON,
    ArticlePastSearchCsvToJSON,
    ArticlePastSearchDefaultCondition,
    ArticlePastSearchDefaultConditionFromJSON,
    ArticlePastSearchDefaultConditionToJSON,
    ArticlePastSearchExcel,
    ArticlePastSearchExcelFromJSON,
    ArticlePastSearchExcelToJSON,
    ArticlePastSearchSummary,
    ArticlePastSearchSummaryFromJSON,
    ArticlePastSearchSummaryToJSON,
    ArticlePastSearchType,
    ArticlePastSearchTypeFromJSON,
    ArticlePastSearchTypeToJSON,
    ArticlePastSearchV2,
    ArticlePastSearchV2FromJSON,
    ArticlePastSearchV2ToJSON,
    BadRequest,
    BadRequestFromJSON,
    BadRequestToJSON,
    Conflict,
    ConflictFromJSON,
    ConflictToJSON,
    Forbidden,
    ForbiddenFromJSON,
    ForbiddenToJSON,
    NotFound,
    NotFoundFromJSON,
    NotFoundToJSON,
    PublicityFlag,
    PublicityFlagFromJSON,
    PublicityFlagToJSON,
    RegisterArticlePastSearchPaid,
    RegisterArticlePastSearchPaidFromJSON,
    RegisterArticlePastSearchPaidToJSON,
    RegisterArticlePastSearchPaidBody,
    RegisterArticlePastSearchPaidBodyFromJSON,
    RegisterArticlePastSearchPaidBodyToJSON,
    Unauthorized,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UpdateArticlePastSearchAutoRenew,
    UpdateArticlePastSearchAutoRenewFromJSON,
    UpdateArticlePastSearchAutoRenewToJSON,
    UpdateArticlePastSearchAutoRenewBody,
    UpdateArticlePastSearchAutoRenewBodyFromJSON,
    UpdateArticlePastSearchAutoRenewBodyToJSON,
} from '../models';

export interface ArticlePastSearchCSVRequest {
    reportId: number;
}

export interface ArticlePastSearchExcelRequest {
    reportId: number;
}

export interface ArticlePastSearchSummaryRequest {
    keyword: Array<string>;
    searchType: ArticlePastSearchType;
    startDate: string;
    endDate: string;
    pubFlag: Array<PublicityFlag>;
    ignoreKeyword?: Array<string> | null;
}

export interface ArticlePastSearchV2Request {
    keyword: Array<string>;
    searchType: ArticlePastSearchType;
    startDate: string;
    endDate: string;
    page: number;
    pubFlag: Array<PublicityFlag>;
    ignoreKeyword?: Array<string> | null;
}

export interface RegisterArticlePastSearchPaidRequest {
    registerArticlePastSearchPaidBody: RegisterArticlePastSearchPaidBody;
}

export interface UpdateArticlePastSearchAutoRenewRequest {
    updateArticlePastSearchAutoRenewBody: UpdateArticlePastSearchAutoRenewBody;
}

/**
 * 
 */
export class ArticlePastSearchApi extends runtime.BaseAPI {

    /**
     * 過去記事検索のCSVダウンロードAPI   * `202` - バックエンドでデータ生成中は202が返却される。3秒後フロントから再度リクエスト。   * `400` - 無料トライアルの場合 
     * 過去記事検索のCSVダウンロード
     */
    async articlePastSearchCSVRaw(requestParameters: ArticlePastSearchCSVRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticlePastSearchCsv>> {
        if (requestParameters.reportId === null || requestParameters.reportId === undefined) {
            throw new runtime.RequiredError('reportId','Required parameter requestParameters.reportId was null or undefined when calling articlePastSearchCSV.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webclipping/api/v1/article/past_search/{report_id}/get-csv`.replace(`{${"report_id"}}`, encodeURIComponent(String(requestParameters.reportId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticlePastSearchCsvFromJSON(jsonValue));
    }

    /**
     * 過去記事検索のCSVダウンロードAPI   * `202` - バックエンドでデータ生成中は202が返却される。3秒後フロントから再度リクエスト。   * `400` - 無料トライアルの場合 
     * 過去記事検索のCSVダウンロード
     */
    async articlePastSearchCSV(requestParameters: ArticlePastSearchCSVRequest, initOverrides?: RequestInit): Promise<ArticlePastSearchCsv> {
        const response = await this.articlePastSearchCSVRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 過去記事検索のExcelダウンロードAPI   * `202` - バックエンドでデータ生成中は202が返却される。3秒後フロントから再度リクエスト。   * `400` - 無料トライアルの場合 
     * 過去記事検索のExcelダウンロード
     */
    async articlePastSearchExcelRaw(requestParameters: ArticlePastSearchExcelRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticlePastSearchExcel>> {
        if (requestParameters.reportId === null || requestParameters.reportId === undefined) {
            throw new runtime.RequiredError('reportId','Required parameter requestParameters.reportId was null or undefined when calling articlePastSearchExcel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webclipping/api/v1/article/past_search/{report_id}/get-excel`.replace(`{${"report_id"}}`, encodeURIComponent(String(requestParameters.reportId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticlePastSearchExcelFromJSON(jsonValue));
    }

    /**
     * 過去記事検索のExcelダウンロードAPI   * `202` - バックエンドでデータ生成中は202が返却される。3秒後フロントから再度リクエスト。   * `400` - 無料トライアルの場合 
     * 過去記事検索のExcelダウンロード
     */
    async articlePastSearchExcel(requestParameters: ArticlePastSearchExcelRequest, initOverrides?: RequestInit): Promise<ArticlePastSearchExcel> {
        const response = await this.articlePastSearchExcelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 過去記事検索のグラフデータ取得をするAPI   * `400` - 無料トライアルの場合 
     * 過去記事検索のグラフデータ取得
     */
    async articlePastSearchSummaryRaw(requestParameters: ArticlePastSearchSummaryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticlePastSearchSummary>> {
        if (requestParameters.keyword === null || requestParameters.keyword === undefined) {
            throw new runtime.RequiredError('keyword','Required parameter requestParameters.keyword was null or undefined when calling articlePastSearchSummary.');
        }

        if (requestParameters.searchType === null || requestParameters.searchType === undefined) {
            throw new runtime.RequiredError('searchType','Required parameter requestParameters.searchType was null or undefined when calling articlePastSearchSummary.');
        }

        if (requestParameters.startDate === null || requestParameters.startDate === undefined) {
            throw new runtime.RequiredError('startDate','Required parameter requestParameters.startDate was null or undefined when calling articlePastSearchSummary.');
        }

        if (requestParameters.endDate === null || requestParameters.endDate === undefined) {
            throw new runtime.RequiredError('endDate','Required parameter requestParameters.endDate was null or undefined when calling articlePastSearchSummary.');
        }

        if (requestParameters.pubFlag === null || requestParameters.pubFlag === undefined) {
            throw new runtime.RequiredError('pubFlag','Required parameter requestParameters.pubFlag was null or undefined when calling articlePastSearchSummary.');
        }

        const queryParameters: any = {};

        if (requestParameters.keyword) {
            queryParameters['keyword[]'] = requestParameters.keyword;
        }

        if (requestParameters.ignoreKeyword) {
            queryParameters['ignore_keyword[]'] = requestParameters.ignoreKeyword;
        }

        if (requestParameters.searchType !== undefined) {
            queryParameters['search_type'] = requestParameters.searchType;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = requestParameters.startDate;
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = requestParameters.endDate;
        }

        if (requestParameters.pubFlag) {
            queryParameters['pub_flag[]'] = requestParameters.pubFlag;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webclipping/api/v1/article/past_search/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticlePastSearchSummaryFromJSON(jsonValue));
    }

    /**
     * 過去記事検索のグラフデータ取得をするAPI   * `400` - 無料トライアルの場合 
     * 過去記事検索のグラフデータ取得
     */
    async articlePastSearchSummary(requestParameters: ArticlePastSearchSummaryRequest, initOverrides?: RequestInit): Promise<ArticlePastSearchSummary> {
        const response = await this.articlePastSearchSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 有料化後に使用する過去記事検索API   * `200` - 無料版にも関わらずquery parameterのstart_dateとend_dateが過去1ヶ月分以外を指している場合   * `200` - 無料版にも関わらずquery parameterのpub_flagが全てチェックされていない場合   * `200` - 無料版にも関わらずquery parameterのpageが1以外の場合   * `200` - 検索結果が0件だった場合   * `400` - キーワードが0個のとき   * `400` - 6個以上のキーワードが送られたとき   * `400` - 6個以上の除外キーワードが送られたとき   * `400` - 有料版でstart_date > end_dateのとき   * `400` - pub_flagに0,1,2以外の値が入っている時   * `400` - pageが0以下   * `400` - pageが存在するページ数よりも大きいとき   * `400` - 1日の検索上限を超えた場合 
     * 有料化後に使用する過去記事検索API
     */
    async articlePastSearchV2Raw(requestParameters: ArticlePastSearchV2Request, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticlePastSearchV2>> {
        if (requestParameters.keyword === null || requestParameters.keyword === undefined) {
            throw new runtime.RequiredError('keyword','Required parameter requestParameters.keyword was null or undefined when calling articlePastSearchV2.');
        }

        if (requestParameters.searchType === null || requestParameters.searchType === undefined) {
            throw new runtime.RequiredError('searchType','Required parameter requestParameters.searchType was null or undefined when calling articlePastSearchV2.');
        }

        if (requestParameters.startDate === null || requestParameters.startDate === undefined) {
            throw new runtime.RequiredError('startDate','Required parameter requestParameters.startDate was null or undefined when calling articlePastSearchV2.');
        }

        if (requestParameters.endDate === null || requestParameters.endDate === undefined) {
            throw new runtime.RequiredError('endDate','Required parameter requestParameters.endDate was null or undefined when calling articlePastSearchV2.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling articlePastSearchV2.');
        }

        if (requestParameters.pubFlag === null || requestParameters.pubFlag === undefined) {
            throw new runtime.RequiredError('pubFlag','Required parameter requestParameters.pubFlag was null or undefined when calling articlePastSearchV2.');
        }

        const queryParameters: any = {};

        if (requestParameters.keyword) {
            queryParameters['keyword[]'] = requestParameters.keyword;
        }

        if (requestParameters.ignoreKeyword) {
            queryParameters['ignore_keyword[]'] = requestParameters.ignoreKeyword;
        }

        if (requestParameters.searchType !== undefined) {
            queryParameters['search_type'] = requestParameters.searchType;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['start_date'] = requestParameters.startDate;
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['end_date'] = requestParameters.endDate;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pubFlag) {
            queryParameters['pub_flag[]'] = requestParameters.pubFlag;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webclipping/api/v2/article/past_search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticlePastSearchV2FromJSON(jsonValue));
    }

    /**
     * 有料化後に使用する過去記事検索API   * `200` - 無料版にも関わらずquery parameterのstart_dateとend_dateが過去1ヶ月分以外を指している場合   * `200` - 無料版にも関わらずquery parameterのpub_flagが全てチェックされていない場合   * `200` - 無料版にも関わらずquery parameterのpageが1以外の場合   * `200` - 検索結果が0件だった場合   * `400` - キーワードが0個のとき   * `400` - 6個以上のキーワードが送られたとき   * `400` - 6個以上の除外キーワードが送られたとき   * `400` - 有料版でstart_date > end_dateのとき   * `400` - pub_flagに0,1,2以外の値が入っている時   * `400` - pageが0以下   * `400` - pageが存在するページ数よりも大きいとき   * `400` - 1日の検索上限を超えた場合 
     * 有料化後に使用する過去記事検索API
     */
    async articlePastSearchV2(requestParameters: ArticlePastSearchV2Request, initOverrides?: RequestInit): Promise<ArticlePastSearchV2> {
        const response = await this.articlePastSearchV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 過去記事検索の契約情報を取得できるAPI
     * 過去記事検索の契約情報
     */
    async getArticlePastSearchContractRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticlePastSearchContractResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webclipping/api/v1/article/past_search/contract`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticlePastSearchContractResponseFromJSON(jsonValue));
    }

    /**
     * 過去記事検索の契約情報を取得できるAPI
     * 過去記事検索の契約情報
     */
    async getArticlePastSearchContract(initOverrides?: RequestInit): Promise<ArticlePastSearchContractResponse> {
        const response = await this.getArticlePastSearchContractRaw(initOverrides);
        return await response.value();
    }

    /**
     * 企業単位での検索可否や件数取得用API
     * 過去記事検索の初期条件を取得するAPI
     */
    async getArticlePastSearchDefaultConditionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<ArticlePastSearchDefaultCondition>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webclipping/api/v1/article/past_search/default_search_condition`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticlePastSearchDefaultConditionFromJSON(jsonValue));
    }

    /**
     * 企業単位での検索可否や件数取得用API
     * 過去記事検索の初期条件を取得するAPI
     */
    async getArticlePastSearchDefaultCondition(initOverrides?: RequestInit): Promise<ArticlePastSearchDefaultCondition> {
        const response = await this.getArticlePastSearchDefaultConditionRaw(initOverrides);
        return await response.value();
    }

    /**
     * 過去記事検索有料版への申込みAPI   * `403` - 配信権限がないユーザーの場合   * `409` - すでに有料版に申し込んでいる場合 
     * 過去記事検索有料版への申込み
     */
    async registerArticlePastSearchPaidRaw(requestParameters: RegisterArticlePastSearchPaidRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RegisterArticlePastSearchPaid>> {
        if (requestParameters.registerArticlePastSearchPaidBody === null || requestParameters.registerArticlePastSearchPaidBody === undefined) {
            throw new runtime.RequiredError('registerArticlePastSearchPaidBody','Required parameter requestParameters.registerArticlePastSearchPaidBody was null or undefined when calling registerArticlePastSearchPaid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/webclipping/api/v1/article/past_search/paid/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterArticlePastSearchPaidBodyToJSON(requestParameters.registerArticlePastSearchPaidBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegisterArticlePastSearchPaidFromJSON(jsonValue));
    }

    /**
     * 過去記事検索有料版への申込みAPI   * `403` - 配信権限がないユーザーの場合   * `409` - すでに有料版に申し込んでいる場合 
     * 過去記事検索有料版への申込み
     */
    async registerArticlePastSearchPaid(requestParameters: RegisterArticlePastSearchPaidRequest, initOverrides?: RequestInit): Promise<RegisterArticlePastSearchPaid> {
        const response = await this.registerArticlePastSearchPaidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 過去記事検索有料版への申込みAPI   * `400` - 無料トライアルの場合。   * `403` - 配信権限がないユーザーの場合。 
     * 過去記事検索有料版の自動更新有無を切り替えるAPI
     */
    async updateArticlePastSearchAutoRenewRaw(requestParameters: UpdateArticlePastSearchAutoRenewRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<UpdateArticlePastSearchAutoRenew>> {
        if (requestParameters.updateArticlePastSearchAutoRenewBody === null || requestParameters.updateArticlePastSearchAutoRenewBody === undefined) {
            throw new runtime.RequiredError('updateArticlePastSearchAutoRenewBody','Required parameter requestParameters.updateArticlePastSearchAutoRenewBody was null or undefined when calling updateArticlePastSearchAutoRenew.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/webclipping/api/v1/article/past_search/paid/auto_renew`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateArticlePastSearchAutoRenewBodyToJSON(requestParameters.updateArticlePastSearchAutoRenewBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateArticlePastSearchAutoRenewFromJSON(jsonValue));
    }

    /**
     * 過去記事検索有料版への申込みAPI   * `400` - 無料トライアルの場合。   * `403` - 配信権限がないユーザーの場合。 
     * 過去記事検索有料版の自動更新有無を切り替えるAPI
     */
    async updateArticlePastSearchAutoRenew(requestParameters: UpdateArticlePastSearchAutoRenewRequest, initOverrides?: RequestInit): Promise<UpdateArticlePastSearchAutoRenew> {
        const response = await this.updateArticlePastSearchAutoRenewRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
